import React from 'react'
import { Link } from 'react-router-dom'
import logo from '../../assets/images/logo/logo_01.png'

const Footer7 = () => {
    return (
        <>
            <footer>
                <div id="footer-seven" className="footer-seven-main-block">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4 col-md-4">
                                <div className="footer-seven-block">
                                    <div className="footer-seven-logo">
                                        <Link to="#" title="">
                                            <img
                                                src={logo}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </Link>
                                    </div>
                                    <div className="footer-seven-dtls">
                                        <p>
                                            Lorem ipsum dolor amet, consectetur sell adipis elit phase nibh
                                            ellentes
                                        </p>
                                    </div>
                                    <ul className="footer-seven-social-icons">
                                        <li>
                                            <Link to="#" title="">
                                                <i className="flaticon-facebook" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" title="">
                                                <i className="flaticon-twitter" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" title="" />
                                            <i className="flaticon-linkedin" />
                                        </li>
                                        <li>
                                            <Link to="#" title="">
                                                <i className="flaticon-pinterest" />
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-8 col-md-8">
                                <div className="row">
                                    <div className="col-lg-4 col-md-4">
                                        <div className="footer-seven-widget">
                                            <h4 className="footer-seven-widget-heading">Useful Links</h4>
                                            <ul className="footer-seven-menu">
                                                <li>
                                                    <Link to="/Aboutus" title="">
                                                        About Us
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/Team" title="">
                                                        Our Team
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/Blog" title="">
                                                        Recent News
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/Portfolio" title="">
                                                        Projects
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" title="">
                                                        Our All Services{" "}
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4">
                                        <div className="footer-seven-widget">
                                            <h4 className="footer-seven-widget-heading">Category</h4>
                                            <ul className="footer-seven-menu">
                                                <li>
                                                    <Link to="#" title="">
                                                        Coordinator
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" title="">
                                                        Architect
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" title="">
                                                        Manager
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" title="">
                                                        Producer
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" title="">
                                                        Designer
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4">
                                        <div className="footer-seven-widget">
                                            <h4 className="footer-seven-widget-heading">Contact</h4>
                                            <ul className="footer-seven-menu">
                                                <li>
                                                    <Link to="tel:332-809-8106" title="">
                                                        332-809-8106
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="mailto:willie.jennings@example.com" title="">
                                                        willie.jennings@example.com
                                                    </Link>
                                                </li>
                                                <li>4517 Washington Ave. Manchester, Kentucky 39495</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tiny-footer-seven-main-block">
                    <div className="container">
                        <div className="tiny-footer-seven-block">
                            <div className="row">
                                <div className="col-lg-6 col-md-6">
                                    <div className="footer-seven-coyright">
                                        © Offex 2025 | All Rights Reserved
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <ul className="tiny-footer-seven-menu">
                                        <li>
                                            <Link to="#" title="">
                                                Terms &amp; Conditions
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/Privace&Policy" title="">
                                                Privacy Policy
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/Contactus" title="">
                                                Contact Us
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

        </>
    )
}

export default Footer7
